// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---src-components-assignment-layout-js": function componentSrcComponentsAssignmentLayoutJs() {
    return import("./../../src/components/assignment-layout.js"
    /* webpackChunkName: "component---src-components-assignment-layout-js" */
    );
  },
  "component---src-components-assignment-list-layout-js": function componentSrcComponentsAssignmentListLayoutJs() {
    return import("./../../src/components/assignment-list-layout.js"
    /* webpackChunkName: "component---src-components-assignment-list-layout-js" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-about-mdx": function componentSrcPagesAboutMdx() {
    return import("./../../src/pages/about.mdx"
    /* webpackChunkName: "component---src-pages-about-mdx" */
    );
  },
  "component---src-pages-index-mdx": function componentSrcPagesIndexMdx() {
    return import("./../../src/pages/index.mdx"
    /* webpackChunkName: "component---src-pages-index-mdx" */
    );
  },
  "component---src-pages-publications-mdx": function componentSrcPagesPublicationsMdx() {
    return import("./../../src/pages/publications.mdx"
    /* webpackChunkName: "component---src-pages-publications-mdx" */
    );
  },
  "component---src-pages-publications-perc-2020-mdx": function componentSrcPagesPublicationsPerc2020Mdx() {
    return import("./../../src/pages/publications/PERC2020.mdx"
    /* webpackChunkName: "component---src-pages-publications-perc-2020-mdx" */
    );
  },
  "component---src-pages-teaching-mdx": function componentSrcPagesTeachingMdx() {
    return import("./../../src/pages/teaching.mdx"
    /* webpackChunkName: "component---src-pages-teaching-mdx" */
    );
  }
};